module.exports = __webpack_public_path__ + "static/media/wedding.3c2e8bc7.png";